<section class="petitionerInfo" *ngIf="user && orderInfo?.stockVehicleDTO">
  <h5 class="petitionerInfo--title">
    {{ 'requestPetitionerTitle' | i18next }}
  </h5>
  <div class="petitionerInfo--infoContainer">
    <div class="petitionerInfo--infoContainer__item">
      <p class="title">{{ 'requestPetitioner' | i18next }}</p>
      <p class="ml">{{ user.fullName }}</p>
    </div>
    <div class="petitionerInfo--infoContainer__item">
      <p class="title">{{ 'nis' | i18next }}</p>
      <p class="ml">{{ user.id }}</p>
    </div>
    <div class="petitionerInfo--infoContainer__item">
      <p class="title">{{ 'phone' | i18next }}</p>
      <p class="ml" *ngIf="!!user.phoneNumber || !!user.mobileNumber">
        {{ user.phoneNumber }} <span *ngIf="hasTelephones"> | </span>
        {{ user.mobileNumber }}
      </p>
    </div>
    <div class="petitionerInfo--infoContainer__item">
      <p class="title">
        {{ 'requestBudgetCenter' | i18next }}
      </p>
      <p class="ml">{{ user.department.costCenter }}</p>
    </div>
    <div class="petitionerInfo--infoContainer__item">
      <p class="title">{{ 'requestPetitionerDependency' | i18next }}</p>
      <p class="ml">{{ user.department.id + ' - ' + user.department.name }}</p>
    </div>
    <div class="petitionerInfo--infoContainer__item">
      <p class="title">{{ 'email' | i18next }}</p>
      <p class="ml petitionerInfo__email">{{ user.email }}</p>
    </div>
    <div class="petitionerInfo--infoContainer__item" *ngIf="isDetail">
      <p class="title">{{ 'additionalPhone' | i18next }}</p>
      <p class="ml">
        {{
          orderInfo
            ? orderInfo.contactInfo.phoneNumber
              ? orderInfo.contactInfo.phoneNumber
              : emptyData
            : emptyData
        }}
      </p>
    </div>
    <div class="petitionerInfo--infoContainer__item" *ngIf="isDetail">
      <p class="title">{{ 'additionalEmail' | i18next }}</p>
      <p class="ml">
        {{
          orderInfo
            ? orderInfo.contactInfo.email
              ? orderInfo.contactInfo.email
              : emptyData
            : emptyData
        }}
      </p>
    </div>
  </div>
</section>
<section class="petitionerInfo" *ngIf="user && !orderInfo?.stockVehicleDTO">
  <h5 class="petitionerInfo--title">
    {{ 'requestPetitionerTitle' | i18next }}
  </h5>
  <div class="petitionerInfo--infoContainer">
    <div class="petitionerInfo--infoContainer__item">
      <p class="title">{{ 'requestPetitioner' | i18next }}</p>
      <p class="ml">{{ user.fullName }}</p>
    </div>
    <div class="petitionerInfo--infoContainer__item">
      <p class="title">{{ 'phone' | i18next }}</p>
      <p class="ml">
        {{ user.phoneNumber }} <span *ngIf="hasTelephones"> | </span>
        {{ user.mobileNumber }}
      </p>
    </div>
    <div class="petitionerInfo--infoContainer__item">
      <p class="title" *ngIf="!isDetail">
        {{ 'requestPetitionerCenter' | i18next }}
      </p>
      <p class="title" *ngIf="isDetail">
        {{ 'requestBudgetCenter' | i18next }}
      </p>
      <p class="ml">{{ user.department.costCenter }}</p>
    </div>
    <div class="petitionerInfo--infoContainer__item">
      <p class="title">{{ 'requestPetitionerDependency' | i18next }}</p>
      <p class="ml">{{ user.department.id + ' - ' + user.department.name }}</p>
    </div>
    <div class="petitionerInfo--infoContainer__item">
      <p class="title">{{ 'email' | i18next }}</p>
      <p class="ml text-truncate">{{ user.email }}</p>
    </div>
    <div class="petitionerInfo--infoContainer__item" *ngIf="isDetail">
      <p class="title">{{ 'additionalPhone' | i18next }}</p>
      <p class="ml">
        {{
          orderInfo
            ? orderInfo.contactInfo
              ? orderInfo.contactInfo.phoneNumber
              : emptyData
            : emptyData
        }}
      </p>
    </div>
    <div class="petitionerInfo--infoContainer__item">
      <p class="title">{{ 'nis' | i18next }}</p>
      <p class="ml">{{ user.nis }}</p>
    </div>
    <div class="petitionerInfo--infoContainer__item" *ngIf="isDetail">
      <p class="title">{{ 'additionalEmail' | i18next }}</p>
      <p class="ml">
        {{
          orderInfo
            ? orderInfo.contactInfo
              ? orderInfo.contactInfo.email
              : emptyData
            : emptyData
        }}
      </p>
    </div>
    <div class="petitionerInfo--infoContainer__item" *ngIf="isDetail">
      <p class="title">{{ 'typeEndowment' | i18next }}</p>
      <p>{{ endowmentMaxValue }}</p>
    </div>
    <div class="petitionerInfo--infoContainer__item" *ngIf="isDetail">
      <p class="title">{{ 'typeArr' | i18next }}</p>
      <p>{{ arrMaxValue }}</p>
    </div>
  </div>
</section>
